import {
  NPM,
  Yarn,
  getRepoType,
  createPackageManager,
} from '@wix/package-manager';

export async function resolvePackageManager(
  projectFolder: string,
  options: { yarn?: boolean; npm?: boolean }
) {
  const repoType = await getRepoType(projectFolder);
  if (options.yarn) {
    return new Yarn(repoType, 'yarn');
  }

  if (options.npm) {
    return new NPM(repoType);
  }

  return createPackageManager(repoType);
}
